import axios from "axios";
import { Urls } from ".././urls";

export const getAuthorListingRepo = (params) => {
    return axios({
        method: "GET",
        url: Urls.GET_AUTHOR_PROFILE_API,
        params: params,
    });
};

export const getAuthorDataRepo = (id) => {
    return axios({
        method: "GET",
        url: Urls.GET_AUTHOR_PROFILE_API + "/" + id,
    });
};

export const getAuthorFilterRepo = (params) => {
    return axios({
        method: "GET",
        url: Urls.GET_AUTHOR_PROFILE_FILTER_API,
        params: params,
    });
};

export const getLocationDataRepo = (params) => {
    return axios({
        method: "GET",
        url: Urls.GET_AUTHOR_PROFILE_FILTER_API,
        params: params,
    });
};

export const postAuthorProfileRepo = (data) => {
    return axios({
        method: "POST",
        url: Urls.GET_AUTHOR_PROFILE_API,
        data: data,
    });
};

export const putAuthorProfileRepo = (id, data) => {
    return axios({
        method: "PUT",
        url: Urls.GET_AUTHOR_PROFILE_API + "/" + id,
        data: data,
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });
};

export const deleteAuthorProfileRepo = (id) => {
    return axios({
        method: "DELETE",
        url: Urls.GET_AUTHOR_PROFILE_API + "/" + id,
    });
};